import PickupCardCreation from '@/api/pickup-card-creation'
import StudentProfile from '@/api/student-profile'
import { baseState, baseMutations } from '@/store/mixins'
import ClassOperation from '@/api/class-operation'
import SubProgram from '@/api/sub-program'
import branch from '@/api/branch'

export const state = {
  ...baseState,
  editData: {},
  photoBlob: '',
  is_print_card: null,
  parents: [],
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA (state, data) {
    state.editData = data
  },
  SET_PHOTO_BLOB (state, blob) {
    state.photoBlob = blob
  },
  RECEIVE_PARENTS (state, blob) {
    state.parents = blob
  },
  SET_IS_PRINT_CARD (state, value) {
    state.is_print_card = value
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true,
        filter: {
          is_print_card: context.state.is_print_card
        }
      },
      attrubutes
    )
    return PickupCardCreation.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async uploadPhoto (context, data) {
    return PickupCardCreation.uploadPhoto(data)
  },
  store (context, data) {
    return PickupCardCreation.store(data)
  },
  async find (context, id) {
    if (_.isEmpty(context.state.editData)) {
      let response = await PickupCardCreation.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  update (context, { id, data }) {
    return PickupCardCreation.update(id, data)
  },
  destroy (context, data) {
    return PickupCardCreation.destroy(data)
  },
  increaseCounter (context, id) {
    return PickupCardCreation.increaseCounter(id)
  },

  fetchParent (context, student_id) {
    return StudentProfile.get({
      params: {
        page: -1,
        include:
          'parent,parent.province,parent.district,parent.commune,parent.village',
        fields: {
          setup_student_profiles:
            'student_id,student_parent_id,card_number,gender,first_name_en,last_name_en,first_name_kh,last_name_kh,photo,ext_card_number'
        },
        filter: {
          student_id_filter: student_id
        }
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    }).then(response => {
      context.commit('RECEIVE_PARENTS', response.data[0].parent)
      return Promise.resolve(response)
    })
  },

  printCard (context, data) {
    return PickupCardCreation.printCard({
      params: {
        side: data.side,
        student_pickup_id_list: data.student_pickup_id_list,
        print_date: data.print_date,
        type: data.type
      }
    })
  },
  getSubProgram (context, attributes = {}) {
    return SubProgram.get({
      params: {
        fields: {
          academic_program_subs: 'acps_id,acps_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getClass (context, acps_id) {
    return ClassOperation.get({
      params: {
        fields: {
          academic_classes: 'class_id,class_name'
        },
        filter: {
          acps_id: acps_id,
          ac_status_id: [1, 3]
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getGuardian (context, attributes = {}) {
    if (attributes.class_id === '' || attributes.class_id === null) return

    return PickupCardCreation.get({
      params: {
        page: -1,
        include: ['student'],
        fields: {
          attendance_student_parent_pickup_cards:
            'student_id,student_pickup_id,card_number,guardian,guardian_kh,relationship'
        },
        filter: {
          guardian_by_student_in_class: attributes.class_id
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  }
}
